import { render, staticRenderFns } from "./ChangeRequestForm.vue?vue&type=template&id=40f524fe&scoped=true&"
import script from "./ChangeRequestForm.vue?vue&type=script&lang=js&"
export * from "./ChangeRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangeRequestForm.vue?vue&type=style&index=0&id=40f524fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f524fe",
  null
  
)

export default component.exports